<script setup>
import { ref, defineEmits } from "vue";
import Search from "./Search.vue";

const promptCancel = ref(false);
const userCancel = ref(false);
const searched = ref("");

const emit = defineEmits(["search", "cancel"]);

const cancel = () => {
  searched.value = "";
  emit("cancel");
};

// Only one search applies at a time, so starting one clears the other
const search = ({ topic, search }) => {
  if (topic === "Prompt" && searched.value !== "") {
    userCancel.value = true;
    promptCancel.value = false;
  } else if (topic === "User" && searched.value !== "") {
    promptCancel.value = true;
    userCancel.value = false;
  }
  searched.value = search;
  emit("search", { topic, search });
};
</script>

<template>
  <div class="mb-5 grid gap-3 md:grid-cols-2">
    <Search
      topic="Prompt"
      :cancelTrigger="promptCancel"
      @search="search($event)"
      @cancel="cancel()"
    />
    <Search
      topic="User"
      :cancelTrigger="userCancel"
      @search="search($event)"
      @cancel="cancel()"
    />
  </div>
</template>
